// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../css-loader/index.js!../../../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../../../postcss-loader/src/index.js??postcss!../../../../../../sass-loader/dist/cjs.js!../../../../../../vue-loader/lib/index.js??vue-loader-options!./SfProductOption.vue?vue&type=style&index=0&lang=scss&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("1965bd6a", content, true, {});